<div [class]="className">
  <ng-container *ngIf="actionData.phone_no!==''">
    <div class="custom-action-item">
      <a matRipple matRippleCentered="true" (click)="onPhoneCallAction(actionData)">
        <div class="inline-icon hyp-action-svg" inlineSVG="shop-icons.svg#ya-local_phone"></div>
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="actionData.latitude!==null && actionData.longitude!==null">
    <div class="custom-action-item">
      <a matRipple matRippleCentered="true" (click)="onDirectionRequest(actionData)">
        <div class="inline-icon hyp-action-svg" inlineSVG="shop-icons.svg#ya-directions"></div>
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="actionData.mail!==''">
    <div class="custom-action-item">
      <a matRipple matRippleCentered="true" (click)="openEMailApp(actionData)">
        <div class="inline-icon hyp-action-svg" inlineSVG="shop-icons.svg#ya-mail_outline"></div>
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="actionData.hasReservation">
    <div class="custom-action-item">
      <a matRipple matRippleCentered="true" (click)="routeToPath('reservation')">
        <div class="inline-icon hyp-action-svg" inlineSVG="shop-icons.svg#ya-reservation"></div>
      </a>
    </div>
  </ng-container>
</div>